import { DashboardHeader } from '@modules/admin/Admin.Header'
import { roomListLoaded } from '@modules/admin/rooms/Rooms.dux'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import RefreshComponent from '@modules/core/icons/RefreshComponent'
import AsyncCustomerField from '@modules/formFields/AsyncCustomerField'
import AsyncProfessionalField from '@modules/formFields/AsyncProfessionalField'
import AsyncGroupProfessionalField from '@modules/formFields/AsyncGroupProfessionalField'
import CalendarField from '@modules/formFields/CalendarField'
import PaginationField from '@modules/formFields/PaginationField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import moment from 'moment'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Consultations from '@services/Consultations'
import RoomTable from './Room.Table'

import './Room.Show.scss'
import SelectProviderField from '@modules/formFields/SelectProviderField'

export class AdminRoomIndex extends Component {
  maxDate = new Date()
  minDate = new Date('2016-09-01')

  state = {
    items_per_page: 25,
    isFetching: false,
    rooms: [],
  }

  fetchRooms = (values) => {
    this.setState({ isFetching: true })

    const { items_per_page } = this.state

    const filters = {
      start_date: moment(values.startDate).startOf('day').toISOString(),
      end_date: moment(values.endDate).endOf('day').toISOString(),
      team_id: values.groupProfessionalFilter ? values.groupProfessionalFilter.id : undefined,
      professional_hash: values.professionalFilter ? values.professionalFilter.hash : undefined,
      customer_hash: values.customerFilter ? values.customerFilter.hash : undefined,
      is_active: values.activeFilter,
      is_answered: values.responseFilter,
      has_surveys: values.rateFilter,
      has_reviews: values.reviewFilter,
      company_api_keys: values.companyFilter ? values.companyFilter.map((co) => co.api_key) : undefined,
      speciality_ids: values.specialityFilter ? values.specialityFilter.map((sp) => sp.id) : undefined,
      provider_ids: values.provider_ids ? values.provider_ids.map((sp) => sp.id) : undefined,
      page: values.page,
    }

    return Consultations.adminRooms
      .index({ items_per_page, ...filters })
      .then((response) => {
        this.props.dispatch(roomListLoaded(response.data))
        return this.setState({
          isFetching: false,
          rooms: response.data,
          lastPage: response.meta.last_page,
          total: response.meta.total,
        })
      })
      .catch((err) => {
        this.setState({ isFetching: false, professionals: [] })
        alert(err.message)
      })
  }

  onRoomUpdateSuccess = () => {
    this.props.submit()
  }

  applyFilters = () => {
    this.props.change('page', 1)
    setTimeout(this.props.submit, 0)
  }

  componentDidMount() {
    // TODO: patch to trigger submit after initialValues are loaded
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { isFetching, rooms, total } = this.state
    const { handleSubmit, error, t } = this.props
    return (
      <>
        <DashboardHeader title={<Trans>Historial de chats</Trans>} total={total} text="chats">
          <RefreshComponent actionOnClickRefresh={this.applyFilters} />
          <button className={'btm btn-primary'} onClick={() => this.props.initialize(this.props.initialValues)}>
            <Trans>Limpiar</Trans>
          </button>
        </DashboardHeader>

        <Form onSubmit={handleSubmit(this.fetchRooms)}>
          <div className="header-filter-container">
            <Field name="startDate" component={CalendarField} minDate={this.minDate} maxDate={this.maxDate} />
            <Field name="endDate" component={CalendarField} minDate={this.minDate} maxDate={this.maxDate} />
            <Field
              name="groupProfessionalFilter"
              component={AsyncGroupProfessionalField}
              placeholder="GroupProfesional"
            />
            <Field name="professionalFilter" component={AsyncProfessionalField} placeholder="Profesional" />

            <Field
              name="activeFilter"
              component={SelectField}
              placeholder={t('Activa')}
              simpleValue
              options={[
                { id: true, name: t('Activa') },
                { id: false, name: t('Cerrada') },
              ]}
            />

            <Field
              name="responseFilter"
              component={SelectField}
              placeholder={t('Respuestas')}
              simpleValue
              options={[
                { id: true, name: t('Respuestas') },
                { id: false, name: t('Sin Responder') },
              ]}
            />

            <Field
              name="rateFilter"
              component={SelectField}
              placeholder={t('Valoradas')}
              simpleValue
              options={[
                { id: true, name: t('Valoradas') },
                { id: false, name: t('Sin Valorar') },
              ]}
            />

            <Field
              name="reviewFilter"
              component={SelectField}
              placeholder={t('Revisadas')}
              simpleValue
              options={[
                { id: true, name: t('Revisadas') },
                { id: false, name: t('Pendientes') },
              ]}
            />

            <AccessControl>
              <Field name="companyFilter" component={SelectCompanyField} multi />
              <Field name="specialityFilter" component={SelectSpecialityField} multi />
              <Field name="customerFilter" component={AsyncCustomerField} placeholder={t('Usuario')} />
              <Field name="provider_ids" component={SelectProviderField} placeholder={t('Proveedores')} multi />
            </AccessControl>
          </div>

          {error && <span style={{ color: 'red', paddingLeft: 18 }}>{error}</span>}

          <Loading isFetching={isFetching} />

          <RoomTable items={rooms} onRoomUpdateSuccess={this.onRoomUpdateSuccess} />

          <Field name="page" component={PaginationField} lastPage={this.state.lastPage} submit={this.props.submit} />
        </Form>
      </>
    )
  }
}

const validate = (values, props) => {
  let errors = {}
  // TODO: This validation is never triggered
  // if (values === {}) return errors

  if (!values.startDate || !values.endDate) {
    errors._error = props.t('Rango de fechas no especificado')
  }

  if (moment(values.startDate).isAfter(moment(values.endDate))) {
    errors._error = props.t('Rango de fechas invalido')
    errors.startDate = props.t('Error de rango')
    errors.endDate = props.t('Error de rango')
  }
  return errors
}

export default compose(
  withTranslation(),
  reduxForm({
    form: 'adminRoomFilters',
    destroyOnUnmount: false,
    initialValues: {
      startDate: moment().add(-1, 'day').toDate(),
      endDate: moment().toDate(),
      page: 1,
    },
    validate,
  })
)(AdminRoomIndex)
